import PublicDel from './PublicDel'
export default PublicDel
